<template>
  <div class="mb-9">
  <v-btn color="primary" :href="url" target="_blank">Let's Go!</v-btn>
  </div>
</template>

<script>
export default {
  name: "ApplicationLink",
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.url = this.$store.state.company.workday_url;
  },
};
</script>